import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IDashboardPersonalChiefForm,
  IDashboardPersonalChiefResponse,
} from '../types';
import {
  DASHBOARD_CHIEF_QUERY_KEY,
  DASHBOARD_CHIEF_URL,
  DASHBOARD_PERMISSIONS,
} from '../constants';

export default function useDashboardChiefQuery(): IContextQueryResult<IDashboardPersonalChiefResponse, Error, IDashboardPersonalChiefForm> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IDashboardPersonalChiefResponse, Error, IDashboardPersonalChiefForm>({
    queryKey: [DASHBOARD_CHIEF_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet(DASHBOARD_CHIEF_URL, {
      signal,
      permission: DASHBOARD_PERMISSIONS.DASHBOARD_PERSONAL_CHIEF,
    }),
    select: (res) => res.chief,
  });
}
